import Mock from 'mockjs';

const LoginUsers = [
    {
        id: 1,
        username: 'admin',
        password: '123456',
        avatar: 'https://raw.githubusercontent.com/taylorchen709/markdown-images/master/vueadmin/user.png',
        name: '张某某'
    }
];

const Users = [];

for (let i = 0; i < 86; i++) {
    Users.push(Mock.mock({
        id: Mock.Random.guid(),
        name: Mock.Random.cname(),
        addr: Mock.mock('@county(true)'),
        'age|18-60': 1,
        birth: Mock.Random.date(),
        sex: Mock.Random.integer(0, 1)
    }));
}

/******************* mock 项目信息******************/
const Projects = []
for (let i = 0; i < 20; i++) {
    Projects.push(
        {
            index: Mock.Random.integer(1, 50),
            customer: Mock.Random.pick(['东方明珠新媒体集团', '上海星巴克咖啡经营有限公司', '百盛餐饮', '人本集团-十足分公司', '友邦']),
            projectName: Mock.Random.pick(['CMS','OTS','OA','DAC','WMS','OMS','MES']),
            isSign: Mock.Random.pick(['关闭', '是']),
            stage: Mock.Random.pick(['已经关闭', '实施阶段', '售前阶段', '需求确认']),
            rate: Mock.Random.float(0, 0, 2),
            leader: Mock.Random.cname(),
            participants: [
                Mock.Random.cname(),
                Mock.Random.cname()
            ].join("、"),
            appointCreateTime: Mock.Random.date(),
            appointEndTime: Mock.Random.date(),
            realCreateTime: Mock.Random.date(),
            realEndTime: Mock.Random.date(),
            consumption: Mock.Random.integer(1, 100),
        }
    )
}

/******************* mock 员工信息******************/
const Employees = []
for (let i = 0; i < 20; i++) {
    Employees.push(
        {
            id: Mock.Random.guid(),
            index: Mock.Random.integer(1, 50),
            name: Mock.Random.cname(),
            age: Mock.Random.integer(18, 70),
            mobile: Mock.mock(/^[1]\d{10}$/),
            sex: Mock.Random.pick(['男', '女']),
            addr: Mock.mock('@county(true)'),
            level: Mock.Random.pick(['初级', '中级', '高级', '资深', '专家'])
        }
    )
}


/******************* mock 员工级别配置******************/
const EmployeesConfig = []
for (let i = 0; i < 20; i++) {
    EmployeesConfig.push(
        {
            index: Mock.Random.integer(1, 50),
            salaryArea: Mock.Random.integer(10000, 30000) + '元',
            level: Mock.Random.pick([0, 1, 2, 3, 4]),
            levelName: Mock.Random.pick(['初级', '中级', '高级', '资深', '专家']),
            rate: Mock.Random.float(0, 0, 2),
            desc: Mock.mock(/^\d{4,5}元\/天$/)
        }
    )
}

/******************* mock 节假日配置******************/
const HolidayConfig = ['2019/4/1'
    , '2019/4/1'
    , '2019/4/4'
    , '2019/4/7'
    , '2019/5/1'
    , '2019/7/1'
    , '2019/8/1'
    , '2019/9/1'
    , '2019/10/1'
    , '2019/11/1'
    , '2019/12/1'
    , '2019/7/13'
    , '2019/7/16'
    , '2019/7/22'
    , '2019/8/7'
    , '2019/8/13'
    , '2019/8/22']

export {LoginUsers, Users, Projects, HolidayConfig, Employees, EmployeesConfig};



// WEBPACK FOOTER //
// ./src/mock/data/user.js